import React from "react";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";

import template1 from '../../assets/templatepaper/splnproc1703.docm';
import template2 from '../../assets/templatepaper/splnproc1703_mac.docm';

function CallForPapers() {
    return (
      <div className="container max-w-8xl relative mx-auto"> 
        <Helmet>
            <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Call For Papers</title>
            <meta name="description" content="The 7th International Conference on Soft Computing in Data Science (SCDS) 2023 that will be held from 24 - 25 January 2023" />
            <meta name="keywords" content="call for papers, scds2023, scds 2023, uitm, aaec, shah alam, conference" />
        </Helmet>   
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
            <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Call for Papers</li>
            </ol>
        </nav>

          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center" >
                  <h1 color="dark">Call for Papers</h1>
                  <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                    <p color="dark-200" style={{ textAlign:'justify'}}>
                        Full paper submission link: <a href="https://edas.info/N29330" target="blank"><u>https://edas.info/N29330</u></a><br/>
                        Full paper template:
                        <p style={{ textAlign:'justify'}}>
                            <a href={template1}><u>Click here to download template</u></a><br/>
                            <a href={template2}><u>Click here to download template (mac version)</u></a>  
                        </p>
                    </p>
                  <div className="text-dark-200">
                      <p color="dark-200" style={{ textAlign:'justify'}}>
                      The 7<sup>th</sup> International Conference on Soft Computing in Data Science (SCDS) 2023 will virtually be held from 24<sup>th</sup> - 25<sup>th</sup> January 2023. With the advancement in 
                      computer technology, data science plays a vital role in various disciplines, including food security, bio-informatics, medical and health informatics, 
                      social sciences, manufacturing, economics, business, and finance. SCDS2023 aims to provide a platform for discussions on leading-edge methods and address 
                      challenges, problems and issues in soft computing in data science and analytics. The role of soft computing in data science is significantly increasing in 
                      every field from engineering to life sciences and with advanced computer technology, solutions for real complex problems can be simplified. For the 
                      advancement of society in the 21st century, there is a need to transfer knowledge and technology to industrial applications to solve real-world problems. 
                      SCDS2023 has invited renowned international and local keynote speakers who are academia or practitioners to share their knowledge and experience in soft 
                      computing in data science.<br/>
                      SCDS2023 aims to attract researchers actively engaged in theoretical and practical aspects of soft computing in data science. Authors are invited to 
                      contribute to the conference by submitting articles in the following areas, but are not limited to:<br/><br/>

                      <li>Big Data Analytics</li>
                      <li>Artificial Intelligence</li>
                      <li>Big Data Technologies</li>
                      <li>Deep Learning</li>
                      <li>Machine Learning</li>
                      <li>Mathematical and Statistical Learning</li>
                      <li>Data Representation and Visualization</li>
                      <li>Graph/Network/Social Mining</li>
                      <li>Computational Intelligence</li>

                      </p>
                  </div>
                  </div>
                  
              </div>
          </div>

  </div>
    );
}

export default CallForPapers;;